@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.wrapper {
  display: flex;
  flex-direction: column;
  padding: 100px 25px;
  text-align: center;
  line-height: 20px;
}

.header {
  font-size: 20px;
  color: @orders-drawer--awaiting-payment-header--text-color;
  font-weight: @bold;
  margin-bottom: 10px;
}

.instructions {
  font-size: 16px;
  color: @orders-drawer--awaiting-payment-instructions--text-color;
  width: 250px;
  margin: auto auto 20px;
}
